export default function UserDetailActivityTab() {
  return (
    <p className="text-secondary" style={{ fontSize: "14px", margin: 0, lineHeight: 1.6 }}>
      Audit log of admin actions affecting this user will appear here in a future update.
    </p>
  );
}
